import { render, staticRenderFns } from "./LayoutComanda.vue?vue&type=template&id=4cb9cb0d&scoped=true&"
import script from "./LayoutComanda.vue?vue&type=script&lang=js&"
export * from "./LayoutComanda.vue?vue&type=script&lang=js&"
import style0 from "./LayoutComanda.vue?vue&type=style&index=0&id=4cb9cb0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9cb0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
